import apiClient from "../api/apiClient";
import { Notify } from "../../helpers/notification";

export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const CLEAR_PROFILE = "CLEAR_PROFILE";

export const LoginAction = (payload, cb) => (dispatch) => {
  apiClient
    .post("/auth/login", { email: payload.email, password: payload.password })
    .then((response) => {
      const data = response?.data?.data;
      if (!data?.token) {
        Notify("danger", "Login failed");
        cb && cb(false);
        return;
      }
      localStorage.setItem("flora_token", data.token);
      dispatch({ type: "LOGIN", payload: data });
      cb && cb(true);
    })
    .catch((err) => {
      const status = err?.response?.status;
      const message =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Login failed";
      cb && cb(false, status, message);
      Notify("danger", message);
    });
};

export const AdminLoginAction = (payload, cb) => () => {
  apiClient.post("api/user/", payload)
    .then((response) => {
      cb && cb(response.data.data);
      Notify("success", response.data.message);
    })
    .catch((err) => {
      cb && cb(false);
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    });
};

// C1 (2026-04-22): forgot-password now hits ania-management-backend.
// Un-authenticated (user isn't logged in yet). apiClient omits the
// x-auth-token header when no token is in localStorage, which is fine —
// the route does not require auth.
export const ForgotPassword = (payload, cb) => () => {
  apiClient
    .post("/auth/forgot-password", { email: payload.email })
    .then((response) => {
      const data = response?.data?.data;
      cb && cb(data);
      Notify("success", data?.msg || "Verification SMS sent");
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "Could not send reset password SMS";
      Notify("danger", message);
      cb && cb(false);
    });
};

// C1 (2026-04-22): un-authenticated reset-password (post-forgot flow from
// login page). Distinct from ChangePasswordAction (which is authenticated,
// used by the profile stepper via JWT). Payload includes zzID because we
// cannot derive the user identity from a token here.
export const ResetPasswordAction = (payload, cb) => (dispatch) => {
  dispatch({ type: "PEOPLE_LOADING" });
  apiClient
    .post("/auth/reset-password", {
      zzID: payload.zzID,
      currentPassword: payload.currentPassword,
      newPassword: payload.newPassword,
      confirmPassword: payload.confirmPassword,
    })
    .then((response) => {
      Notify("success", response?.data?.data?.msg || "Password updated");
      cb && cb(true);
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "Could not reset password";
      Notify("danger", message);
      cb && cb(false);
    })
    .finally(() => dispatch({ type: "PEOPLE_COMPLETE" }));
};

export const ChangeLease = (payload, cb) => (dispatch) => {
  apiClient
    .post("/auth/change-lease", { leaseId: payload.leaseId })
    .then((response) => {
      localStorage.setItem("flora_token", response.data.data.token);
      dispatch({ type: "CHANGE_LEASE", payload: response.data.data.userData });
      cb && cb();
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "Could not change lease";
      Notify("danger", message);
      cb && cb(false);
    });
};

export const getProfile = () => (dispatch) => {
  apiClient
    .get("/auth/profile")
    .then((response) => {
      dispatch({ type: "GET_PROFILE", payload: response.data.data });
      dispatch({ type: "PEOPLE_COMPLETE" });
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    });
};

// updateProfile now routes password changes to the new /auth/change-password
// endpoint. The legacy multipart photo upload path is deferred to a future
// endpoint (see docs/superpowers/specs/2026-04-19-tier1-auth-profile-design.md
// "Pending — captured for later" section).
export const updateProfile = (payload, cb) => (dispatch) => {
  // Backwards-compatible bridge: stepper.js sends FormData with currentPassword
  // / newPassword / confirmPassword fields. Convert to JSON before calling the
  // new endpoint.
  let body = payload;
  if (payload && typeof payload.get === "function") {
    body = {
      currentPassword: payload.get("currentPassword") || "",
      newPassword: payload.get("newPassword") || "",
      confirmPassword: payload.get("confirmPassword") || "",
    };
  }

  // If body has no password fields (e.g. legacy photo-only call from
  // profile.js), it's a no-op.
  if (!body?.currentPassword || !body?.newPassword) {
    cb && cb(false);
    return;
  }

  dispatch(ChangePasswordAction(body, cb));
};

// Old backend metaData endpoint dropped — dashboard sections that used it
// (people, parking) are commented out, and tickets/payments now load from
// the new backend directly via GetRecentTickets / GetRecentPayments.
// Kept as a no-op so existing callers across the app don't crash;
// callbacks fire immediately. Remove once all callers are cleaned up
// (after Tier 2 Parking migration).
export const getDashboardData = (cb) => () => {
  cb && cb();
};

export const ChangePasswordAction = (payload, cb) => (dispatch) => {
  dispatch({ type: "PEOPLE_LOADING" });
  apiClient
    .post("/auth/change-password", payload)
    .then((response) => {
      Notify("success", response?.data?.data?.msg || "Password changed");
      dispatch({ type: "GET_PROFILE", payload: "" });
      cb && cb(true);
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "Could not change password";
      Notify("danger", message);
      cb && cb(false);
    })
    .finally(() => {
      dispatch({ type: "PEOPLE_COMPLETE" });
    });
};

export const VerifyEmailAction = (requestedParams, cb) => (dispatch) => {
  apiClient.get(`api/user/verifyEmail${requestedParams}`)
    .then((response) => {
      cb && cb(response.data);
      dispatch({ type: UPDATE_PROFILE, payload: "success" });
      // Notify("success", response.data.message);
    })
    .catch((err) => {
      cb && cb(err.response.data);
      dispatch({ type: UPDATE_PROFILE, payload: "danger" });
    })
    .catch(() => {
      Notify("danger", "Something Bad Happened :(");
    });
};

// D2 (2026-04-21): all three channels (phone, Email_01, Email_02) now route
// to the new ania-management-backend. Legacy webappbackend endpoints removed
// from this flow. Stepper sets exactly one channel per call, so branch order
// only reflects a consistent check order (mutually exclusive in practice).
export const sendOtp = (payload, cb) => (dispatch) => {
  dispatch({ type: "PEOPLE_LOADING" });

  let endpoint;
  let body;
  if (payload?.Phone_Mobile) {
    endpoint = "/auth/send-phone-otp";
    body = { Phone_Mobile: payload.Phone_Mobile };
  } else if (payload?.Email_01) {
    endpoint = "/auth/send-email-otp";
    body = { Email_01: payload.Email_01 };
  } else if (payload?.Email_02) {
    endpoint = "/auth/send-email-otp";
    body = { Email_02: payload.Email_02 };
  } else {
    dispatch({ type: "PEOPLE_COMPLETE" });
    Notify("danger", "No channel provided");
    return;
  }

  apiClient
    .post(endpoint, body)
    .then((response) => {
      Notify(
        "success",
        response?.data?.data?.msg || "Verification code sent"
      );
      cb && cb();
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "Could not send verification code";
      Notify("danger", message);
    })
    .finally(() => dispatch({ type: "PEOPLE_COMPLETE" }));
};

// D2 (2026-04-21): all three channels routed to the new backend's
// verify-*-otp-and-update-profile endpoints. No legacy fallback.
export const verifyOtp = (payload, cb) => (dispatch) => {
  dispatch({ type: "PEOPLE_LOADING" });

  let endpoint;
  let body;
  if (payload?.Phone_Mobile) {
    endpoint = "/auth/verify-phone-otp-and-update-profile";
    body = { Phone_Mobile: payload.Phone_Mobile, otp: payload.otp };
  } else if (payload?.Email_01) {
    endpoint = "/auth/verify-email-otp-and-update-profile";
    body = { Email_01: payload.Email_01, otp: payload.otp };
  } else if (payload?.Email_02) {
    endpoint = "/auth/verify-email-otp-and-update-profile";
    body = { Email_02: payload.Email_02, otp: payload.otp };
  } else {
    dispatch({ type: "PEOPLE_COMPLETE" });
    Notify("danger", "No channel provided");
    return;
  }

  apiClient
    .post(endpoint, body)
    .then(() => {
      dispatch({ type: UPDATE_PROFILE, payload: true });
      dispatch(getProfile());
      cb && cb(true);
    })
    .catch((err) => {
      const message =
        err?.response?.data?.error || "OTP does not match";
      Notify("danger", message);
    })
    .finally(() => dispatch({ type: "PEOPLE_COMPLETE" }));
};

export const updateMsg = (payload) => (dispatch) => {
  dispatch({ type: "UPDATE_PROFILE", payload });
};

export const setGlobalzzId = (payload) => (dispatch) => {
  dispatch({ type: "SET_GLOBAL_ZZID", payload });
};

export const clearGlobalzzId = () => (dispatch) => {
  dispatch({ type: "CLEAR_GLOBAL_ZZID" });
};

export const updateChangeLeaseSuccess = () => (dispatch) => {
  dispatch({ type: "CLEAR_CHANGELEASE_SUCCESS" });
};

export const updateNoticeToVacateSuccess = (payload) => (dispatch) => {
  dispatch({ type: "UPDATE_NOTICETOVACATE_SUCCESS", payload });
};

export const LogoutAction = () => (dispatch) => {
  localStorage.removeItem("flora_token");
  dispatch({ type: "LOGOUT" });
};

export const getProfileWithLeaseAction = (leaseId, id) => (dispatch) => {
  dispatch({type: "NOTICE_VACATE_LOADING_START"});
  apiClient.get(`/auth/get-profile/${leaseId}/${id}`)
    .then((response) => {
      dispatch({ type: "GET_PROFILE_PUBLIC", payload: response.data.data });
      dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    })
    .catch((error) => {
      Notify("danger", error.message);
      dispatch({type: "NOTICE_VACATE_LOADING_STOP"});
    });
};